/* PUSHAS 2026 — hero tools: size-guide brand chips, editorial topics + search, article shop chip, reviews rating pill, PDP size guide link */
(function () {
  var d = document;
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var DOWN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M6 13l6 6 6-6"/></svg>';
  var LENS = '<svg class="p26-hsearch-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>';

  function wrap() { var w = d.createElement('div'); w.className = 'p26-tools'; return w; }
  function jump(target) {
    if (!target) return;
    target.style.scrollMarginTop = '140px';
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* 1. Size guides: brand chips -> select brand tab + scroll to chart, plus a link to the other guide */
  function sizeGuide() {
    var inner = d.querySelector('.edt-hero .edt-inner');
    var tabs = d.querySelectorAll('#sg-brands .sg-brand');
    if (!inner || !tabs.length || inner.querySelector('.p26-tools')) return;
    var w = wrap(), row = d.createElement('div');
    row.className = 'p26-chips';
    Array.prototype.forEach.call(tabs, function (tab) {
      var b = d.createElement('button');
      b.type = 'button'; b.className = 'p26-chip'; b.textContent = tab.textContent.trim();
      b.addEventListener('click', function () { tab.click(); jump(d.getElementById('sg') || tab); });
      row.appendChild(b);
    });
    var sw = /\/pages\/streetwear-size-guide/.test(location.pathname);
    var x = d.createElement('a');
    x.className = 'p26-chip p26-chip--link'; x.href = sw ? '/pages/size-guide' : '/pages/streetwear-size-guide';
    x.innerHTML = (sw ? 'Sneaker size guide ' : 'Streetwear size guide ') + ARROW;
    row.appendChild(x);
    w.appendChild(row); inner.appendChild(w);
  }

  /* 1b. Product page: "Size guide" link beside "Select size", routed by product type and brand */
  function pdpGuide() {
    var P = window.P26_PROD; if (!P) return;
    var t = String(P.type || ''), v = String(P.vendor || '') + ' ' + String(P.title || ''), url = null, map;
    if (/apparel/i.test(t)) { url = '/pages/streetwear-size-guide'; map = [['geedup', /geedup/i], ['essentials', /fear of god|essentials/i], ['bape', /bathing ape|bape/i], ['hellstar', /hellstar/i], ['supreme', /supreme/i], ['nike', /nike|jordan|nocta/i], ['adidas', /adidas|yeezy/i]]; }
    else if (/sneaker/i.test(t)) { url = '/pages/size-guide'; map = [['nike', /nike|jordan/i], ['asics', /asics/i], ['adidas', /adidas|yeezy/i], ['ugg', /ugg/i], ['new-balance', /new balance/i], ['crocs', /crocs/i], ['onitsuka-tiger', /onitsuka/i], ['puma', /puma/i], ['converse', /converse/i]]; }
    if (!url) return;
    for (var i = 0; i < map.length; i++) { if (map[i][1].test(v)) { url += '#' + map[i][0]; break; } }
    var tries = 0;
    (function add() {
      var heads = d.querySelectorAll('.p26-sizes-head');
      if (!heads.length) { if (tries++ < 40) setTimeout(add, 150); return; }
      Array.prototype.forEach.call(heads, function (h) {
        if (h.querySelector('.p26-sg-link')) return;
        var a = d.createElement('a'); a.className = 'p26-sg-link'; a.href = url; a.textContent = 'Size guide';
        var lab = h.querySelector('.p26-sizes-label');
        lab ? lab.insertAdjacentElement('afterend', a) : h.appendChild(a);
      });
    })();
  }

  /* 2. Editorial index: topic chips + article search */
  function editorial() {
    var mast = d.querySelector('.pj-mast .pj-wrap');
    if (!mast || mast.querySelector('.p26-tools')) return;
    if (!/^\/blogs\/editorial(\/tagged\/[^/]+)?\/?$/.test(location.pathname)) return;
    var base = '/blogs/editorial', cur = location.pathname.replace(/\/$/, '').toLowerCase();
    var topics = [['All stories', base], ['Sneakers', base + '/tagged/sneakers'], ['Streetwear', base + '/tagged/streetwear'], ['Collectibles', base + '/tagged/collectibles']];
    var w = wrap();
    var f = d.createElement('form');
    f.className = 'p26-hsearch'; f.action = '/search'; f.method = 'get'; f.setAttribute('role', 'search');
    f.innerHTML = LENS + '<input type="search" name="q" placeholder="Search stories, e.g. Jordan 4, Pokémon, BAPE" aria-label="Search stories" autocomplete="off"><input type="hidden" name="type" value="article"><input type="hidden" name="options[prefix]" value="last"><button type="submit" aria-label="Search">' + ARROW + '</button>';
    var row = d.createElement('div'); row.className = 'p26-chips';
    topics.forEach(function (t) {
      var a = d.createElement('a');
      a.className = 'p26-chip' + (cur === t[1] ? ' is-active' : ''); a.href = t[1]; a.textContent = t[0];
      row.appendChild(a);
    });
    w.appendChild(f); w.appendChild(row);
    var foot = mast.querySelector('.pj-mast-foot');
    (foot && foot.parentNode === mast) ? mast.insertBefore(w, foot.nextSibling) : mast.appendChild(w);
  }

  /* 3. Article: "Shop this story" chip in the meta row */
  function article() {
    var meta = d.querySelector('.pj-ahead .pj-ameta');
    var card = d.querySelector('.pj-shopcard');
    if (!meta || !card || meta.querySelector('.p26-meta-chip')) return;
    var a = d.createElement('a');
    a.href = '#'; a.className = 'p26-meta-chip'; a.innerHTML = 'Shop this story ' + DOWN;
    a.addEventListener('click', function (e) { e.preventDefault(); card.style.scrollMarginTop = '140px'; card.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    meta.appendChild(a);
  }

  /* 4. Reviews: rating pill from Loox global stats */
  function reviews() {
    if (!/\/pages\/pushas-reviews\/?$/.test(location.pathname)) return;
    var cta = d.querySelector('.pj-phead .pj-phead-cta');
    var raw = String(window.P26_LOOX || '').split(',');
    var avg = parseFloat(raw[0]), n = parseInt(raw[1], 10);
    if (!cta || !avg || !n || d.querySelector('.p26-rating')) return;
    var w = wrap(); w.classList.add('p26-rating');
    var row = d.createElement('div'); row.className = 'p26-chips'; row.style.marginTop = '0'; row.style.marginBottom = '24px';
    var s = d.createElement('span'); s.className = 'p26-chip p26-chip--static';
    s.innerHTML = '<span class="p26-stars" aria-hidden="true">★★★★★</span> ' + avg.toFixed(1) + ' from ' + n.toLocaleString('en-AU') + ' verified reviews';
    row.appendChild(s); w.appendChild(row);
    cta.parentNode.insertBefore(w, cta);
  }

  function run() { try { sizeGuide(); } catch (e) {} try { pdpGuide(); } catch (e) {} try { editorial(); } catch (e) {} try { article(); } catch (e) {} try { reviews(); } catch (e) {} }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run); else run();
})();
